import { DeleteButton, EditButton, List, useTable } from "@refinedev/antd";
import { useUpdate } from "@refinedev/core";
import { Space, Switch, Table, Tag, Typography } from "antd";
import type { TrackedPost } from "../../api/client";

export const TrackedPostList = () => {
  const { tableProps } = useTable<TrackedPost>({
    resource: "tracked-posts",
    sorters: { initial: [{ field: "createdAt", order: "desc" }] },
  });

  const { mutate: update } = useUpdate();

  return (
    <List title="Активные задания" canCreate={false}>
      <Table {...tableProps} rowKey="id">
        <Table.Column<TrackedPost>
          title="Пост"
          dataIndex="caption"
          render={(_, record) => (
            <Space>
              {record.thumbnailUrl && (
                <img
                  src={record.thumbnailUrl}
                  alt=""
                  style={{ width: 48, height: 48, objectFit: "cover", borderRadius: 4 }}
                />
              )}
              <Space direction="vertical" size={0}>
                <Typography.Text ellipsis style={{ maxWidth: 320 }}>
                  {record.caption ?? record.mediaId}
                </Typography.Text>
                {record.permalink && (
                  <Typography.Link href={record.permalink} target="_blank" rel="noreferrer">
                    Открыть в Instagram
                  </Typography.Link>
                )}
              </Space>
            </Space>
          )}
        />

        <Table.Column<TrackedPost>
          title="Триггеры"
          dataIndex="triggerCount"
          render={(_, record) =>
            record.triggerCount === 0 ? (
              <Tag color="orange">не настроены</Tag>
            ) : (
              <Tag color="blue">
                {record.enabledTriggerCount} из {record.triggerCount} активны
              </Tag>
            )
          }
        />

        <Table.Column<TrackedPost>
          title="Ответов"
          dataIndex="repliedCount"
          render={(_, record) => (
            <Space direction="vertical" size={0}>
              <Typography.Text strong>{record.repliedCount}</Typography.Text>
              <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                из {record.commentCount} комментариев
              </Typography.Text>
            </Space>
          )}
        />

        <Table.Column<TrackedPost>
          title="Следим"
          dataIndex="isEnabled"
          render={(_, record) => (
            <Switch
              checked={record.isEnabled}
              onChange={(checked) =>
                update({
                  resource: "tracked-posts",
                  id: record.id,
                  values: { isEnabled: checked },
                })
              }
            />
          )}
        />

        <Table.Column<TrackedPost>
          title=""
          dataIndex="actions"
          render={(_, record) => (
            <Space>
              <EditButton hideText size="small" recordItemId={record.id} />
              <DeleteButton hideText size="small" recordItemId={record.id} />
            </Space>
          )}
        />
      </Table>
    </List>
  );
};
